export default function Footer() {
    return (
        <div id="footer">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="social">
                            <a href=""><li className="fa fa-instagram"></li></a>
                            <a href=""><li className="fa fa-twitter"></li></a>
                            <a href=""><li className="fa fa-facebook-f"></li></a>
                        </div>
                    </div>
                    <div className="col-12">
                        <p>Copyright &#169; 2025 <a href="">Семеен хотел "Тодорини къщи" и механа "Под старата круша"</a> All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}